import React from 'react';
import { UserIcon, MailIcon, PhoneIcon, ShieldCheckIcon, FileTextIcon, BellIcon, GlobeIcon, MoonIcon } from 'lucide-react';
export function Profile() {
  return <div className="flex-1 p-4 lg:p-8 max-w-3xl mx-auto w-full" data-id="element-3895" data-mp="34986rd5arw6r">
      <h1 className="font-display font-bold text-3xl text-dark-navy mb-8" data-id="element-3896" data-mp="34b2v71fs26fl">
        Profile Settings
      </h1>

      <div className="space-y-6" data-id="element-3897" data-mp="3968cfmy8iwxc">
        {/* Personal Info */}
        <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm" data-id="element-3898" data-mp="tueikwsdcmg">
          <div className="flex items-center gap-4 mb-6" data-id="element-3899" data-mp="4t38nqvqncij">
            <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center" data-id="element-3900" data-mp="3mzpzviu1ktsn">
              <UserIcon className="w-8 h-8 text-slate-400" data-id="element-3901" data-mp="3ryu8a7956nhx" />
            </div>
            <div data-id="element-3902" data-mp="3s0x79gs9vqys">
              <h2 className="font-bold text-xl text-slate-900" data-id="element-3903" data-mp="2bkkj5ax2suq1">
                Ahmed Al Mansoori
              </h2>
              <p className="text-slate-500" data-id="element-3904" data-mp="2gjdv2ywpsdo3">Member since 2024</p>
            </div>
            <button className="ml-auto px-4 py-2 bg-slate-50 text-slate-700 rounded-xl font-medium hover:bg-slate-100 transition-colors" data-id="element-3905" data-mp="2a5ohgsdp8ogh">
              Edit
            </button>
          </div>

          <div className="space-y-4" data-id="element-3906" data-mp="266fo3omkmslg">
            <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-3907" data-mp="2k4470qx2vpnv">
              <div className="flex items-center gap-3" data-id="element-3908" data-mp="2f4hvqn0t8jhp">
                <MailIcon className="w-5 h-5 text-slate-400" data-id="element-3909" data-mp="2f6u7ujjvzzmu" />
                <div data-id="element-3910" data-mp="2t37s20ft2f50">
                  <p className="text-sm text-slate-500" data-id="element-3911" data-mp="2t2ppyn6gp6p6">Email</p>
                  <p className="font-medium text-slate-900" data-id="element-3912" data-mp="2p1w0hpddfju6">
                    ahmed@example.com
                  </p>
                </div>
              </div>
              <span className="px-2.5 py-1 bg-success/10 text-success text-xs font-bold rounded-full flex items-center gap-1" data-id="element-3913" data-mp="2xv8z97y49fo6">
                <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-3914" data-mp="3crqck4pv94dd" /> Verified
              </span>
            </div>

            <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-3915" data-mp="37uhr9v9f8k7w">
              <div className="flex items-center gap-3" data-id="element-3916" data-mp="3exeiwu7pop9i">
                <PhoneIcon className="w-5 h-5 text-slate-400" data-id="element-3917" data-mp="3eusbcuktm9ra" />
                <div data-id="element-3918" data-mp="3jwhpwk7955k4">
                  <p className="text-sm text-slate-500" data-id="element-3919" data-mp="3jtn4oqgezgpn">Phone</p>
                  <p className="font-medium text-slate-900" data-id="element-3920" data-mp="3otrksfdeu9fc">+971 50 123 4567</p>
                </div>
              </div>
              <span className="px-2.5 py-1 bg-success/10 text-success text-xs font-bold rounded-full flex items-center gap-1" data-id="element-3921" data-mp="3tn3xbr4teprq">
                <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-3922" data-mp="2hkm0p6q0sir" /> Verified
              </span>
            </div>

            {/* UAE Pass Placeholder */}
            <div className="flex items-center justify-between p-4 bg-gradient-to-r from-slate-50 to-slate-100 rounded-xl border border-slate-200 border-dashed" data-id="element-3923" data-mp="bgy1byhj0bbe">
              <div className="flex items-center gap-3" data-id="element-3924" data-mp="2d79hjg9k1y79">
                <div className="w-8 h-8 bg-black rounded flex items-center justify-center text-white font-bold text-xs" data-id="element-3925" data-mp="2d8ubp4ryjf4l">
                  UAE
                </div>
                <div data-id="element-3926" data-mp="2an3c145alzol">
                  <p className="font-bold text-slate-900" data-id="element-3927" data-mp="2anmtkjr16m23">UAE Pass</p>
                  <p className="text-sm text-slate-500" data-id="element-3928" data-mp="25vl9ibnmfr1i">
                    Verify your identity for higher trust score
                  </p>
                </div>
              </div>
              <button className="px-4 py-2 bg-black text-white rounded-xl font-medium text-sm hover:bg-slate-800 transition-colors" data-id="element-3929" data-mp="1vy76bdqpkyr5">
                Connect
              </button>
            </div>
          </div>
        </div>

        {/* Documents */}
        <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm" data-id="element-3930" data-mp="2on5r6im7uf05">
          <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-3931" data-mp="2jm89e754bmz6">
            My Documents
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-3932" data-mp="2enn8s6lyf1a7">
            <button className="flex flex-col items-center justify-center p-6 bg-slate-50 rounded-xl border border-slate-200 border-dashed hover:border-primary-indigo hover:bg-primary-indigo/5 transition-all group" data-id="element-3933" data-mp="188w2tohz4q9b">
              <ShieldCheckIcon className="w-8 h-8 text-slate-400 group-hover:text-primary-indigo mb-2" data-id="element-3934" data-mp="2s2fp6zrl4owd" />
              <span className="font-medium text-slate-700 group-hover:text-primary-indigo" data-id="element-3935" data-mp="2wv8qterrbh48">
                Emirates ID
              </span>
              <span className="text-xs text-slate-400 mt-1" data-id="element-3936" data-mp="2i36pdqa1gg23">
                Used to verify your account
              </span>
            </button>
            <button className="flex flex-col items-center justify-center p-6 bg-slate-50 rounded-xl border border-slate-200 border-dashed hover:border-primary-indigo hover:bg-primary-indigo/5 transition-all group" data-id="element-3937" data-mp="3atozvcd3djpj">
              <FileTextIcon className="w-8 h-8 text-slate-400 group-hover:text-primary-indigo mb-2" data-id="element-3938" data-mp="30uze38i2rf40" />
              <span className="font-medium text-slate-700 group-hover:text-primary-indigo" data-id="element-3939" data-mp="35tkeb7xbtysg">
                Upload CV
              </span>
            </button>
          </div>
        </div>

        {/* Preferences */}
        <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-4" data-id="element-3940" data-mp="1uh04w4jfh7uz">
          <h3 className="font-bold text-lg text-slate-900 mb-2" data-id="element-3941" data-mp="cg8wq7dwi3qo">
            App Preferences
          </h3>

          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-3942" data-mp="7l3cre426z58">
            <div className="flex items-center gap-3" data-id="element-3943" data-mp="lhz08bl24t4t">
              <BellIcon className="w-5 h-5 text-slate-500" data-id="element-3944" data-mp="hgn9g2qg61v1" />
              <span className="font-medium text-slate-700" data-id="element-3945" data-mp="hf2fae81okxp">Notifications</span>
            </div>
            <div className="relative inline-block w-10 h-6 rounded-full bg-primary-indigo cursor-pointer" data-id="element-3946" data-mp="3puvv0qujxsdp">
              <span className="absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform translate-x-4" data-id="element-3947" data-mp="3kw2esqnvrn9u" />
            </div>
          </div>

          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-3948" data-mp="3txs49qy7cc4z">
            <div className="flex items-center gap-3" data-id="element-3949" data-mp="367xs7blpirls">
              <GlobeIcon className="w-5 h-5 text-slate-500" data-id="element-3950" data-mp="366mqdhbtntxb" />
              <span className="font-medium text-slate-700" data-id="element-3951" data-mp="326w3hopf1xy2">Language</span>
            </div>
            <select className="bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-sm font-medium text-slate-700 focus:outline-none focus:border-primary-indigo" data-id="element-3952" data-mp="155zyz0soa8rf">
              <option data-id="element-3953" data-mp="1ew1e3331sgu7">English</option>
              <option data-id="element-3954" data-mp="1ex2yvz9v8hp4">العربية</option>
            </select>
          </div>

          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-3955" data-mp="1jvxkf8z7wkcx">
            <div className="flex items-center gap-3" data-id="element-3956" data-mp="m8p19kmovne3">
              <MoonIcon className="w-5 h-5 text-slate-500" data-id="element-3957" data-mp="ma06zpzp357u" />
              <span className="font-medium text-slate-700" data-id="element-3958" data-mp="r81q2ax4f4jb">Theme</span>
            </div>
            <select className="bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-sm font-medium text-slate-700 focus:outline-none focus:border-primary-indigo" data-id="element-3959" data-mp="w5tnfkgjbiuw">
              <option data-id="element-3960" data-mp="27lidikp34xzx">Light</option>
              <option data-id="element-3961" data-mp="27k70du9r2dw5">Dark</option>
              <option data-id="element-3962" data-mp="27ncop7ak1bqt">System</option>
            </select>
          </div>
        </div>
      </div>
    </div>;
}